module.exports = __webpack_public_path__ + "img/sceneIcon1-5.7b08578a.png";